import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
 #GROUPTOAST
\*------------------------------------ */
/**
 * 1)
 */
[popover] {
  position: unset;
  inset: unset;
  width: unset;
  height: unset;
  margin: unset;
  border: unset;
  padding: unset;
  color: unset;
  background-color: unset;
  overflow: unset;
}

.cat-c-group-toast {
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: var(--cat-z-index-500);
}

/**
 * Toast positioned to the top of the window
 */
.cat-c-toast--pos-top {
  position: fixed;
  inset-block-start: var(--cat-group-toast--inset-block-start, calc(var(--size-base-unit) * 3.75));
  inset-inline-start: var(--cat-group-toast--inset-inline-start, 50%);
  transform: translateX(var(--rtlTranslateX, -50%));
}

/**
   * Toast positioned to the bottom of the window
   */
.cat-c-toast--pos-bottom {
  position: fixed;
  inset-block-end: var(--cat-group-toast--inset-block-end, calc(var(--size-base-unit) * 3.75));
  inset-inline-start: var(--cat-group-toast--inset-inline-start, 50%);
  transform: translateX(var(--rtlTranslateX, -50%));
}

/**
   * Toast positioned to the left of the window
   */
.cat-c-toast--pos-left {
  position: fixed;
  inset-block-start: var(--cat-group-toast--inset-block-start, calc(var(--size-base-unit) * 3.75));
  inset-inline-start: var(--cat-group-toast--inset-inline-start, calc(var(--size-base-unit) * 3.75));
  transform: translateX(0);
  max-width: calc(100% - 2 * var(--cat-group-toast--inset-inline-start, calc(var(--size-base-unit) * 3.75)));
  /**
    * Toast positioned to the bottom left of the window
    */
}
.cat-c-toast--pos-left.cat-c-toast--pos-bottom {
  inset-block-start: var(--cat-group-toast--inset-block-start, auto);
}

/**
   * Toast positioned to the right
   */
.cat-c-toast--pos-right {
  position: fixed;
  inset-block-start: var(--cat-group-toast--inset-block-start, calc(var(--size-base-unit) * 3.75));
  inset-inline: var(--cat-group-toast--inset-inline-start, auto) var(--cat-group-toast--inset-inline-end, calc(var(--size-base-unit) * 3.75));
  transform: translateX(0);
  max-width: calc(100% - 2 * var(--cat-group-toast--inset-inline-end, calc(var(--size-base-unit) * 3.75)));
  /**
    * Toast positioned to the bottom right of the window
    */
}
.cat-c-toast--pos-right.cat-c-toast--pos-bottom {
  inset-block-start: var(--cat-group-toast--inset-block-start, auto);
}

/**
   * Toast positioned in the center
   */
.cat-c-toast--pos-center {
  position: fixed;
  inset-block-start: var(--cat-group-toast--inset-block-start, calc(var(--size-base-unit) * 3.75));
  inset-inline-start: var(--cat-group-toast--inset-inline-start, 50%);
  transform: translateX(var(--rtlTranslateX, -50%));
  max-width: 100%;
  /**
    * Toast positioned to the bottom center of the window
    */
}
.cat-c-toast--pos-center.cat-c-toast--pos-bottom {
  inset-block-start: var(--cat-group-toast--inset-block-start, auto);
}
`;
       